var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13V11H16V13H0ZM0 10V8H16V10H0ZM7 21V17.8L5.4 19.4L4 18L8 14L12 18L10.6 19.4L9 17.85V21H7ZM8 7L4 3L5.4 1.6L7 3.2V0H9V3.2L10.6 1.6L12 3L8 7Z",
    fill: "#EE3B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.19a886268f7cb680e786cfa0ce6f6148.svg";
export { ForwardRef as ReactComponent };